export default function CreativeListController(
  CreativeService,
  CurrentUserService,
  DataService,
  ExamplesService,
  localStorageService
) {
  const vm = this;
  vm.setLastActiveTab = setLastActiveTab;
  vm.initUserCreatives = initUserCreatives;
  vm.initExampleCreatives = initExampleCreatives;

  vm.$onInit = function() {
    vm.userSignedIn = false;
    vm.lastActiveTab = getLastActiveTab();

    return CurrentUserService.get().then(user => {
      vm.userSignedIn = !!user;
      vm.activeTab = 'exampleCreatives';
      return initExampleCreatives();
    });
  };

  function initUserCreatives() {
    return DataService.initUserCreatives().then(() => {
      if (!CreativeService.creative.action) {
        CreativeService.setCreative(DataService.userCreatives[0]);
      }
    });
  }

  function initExampleCreatives() {
    return ExamplesService.getExamples().then(examples => {
      if (!CreativeService.creative.action) {
        CreativeService.setCreative(examples[0].creative);
      }
    });
  }

  function setLastActiveTab(tab) {
    localStorageService.set('lastActiveTab', tab);
  }

  function getLastActiveTab() {
    return localStorageService.get('lastActiveTab');
  }

  return vm;
}

CreativeListController.$inject = [
  'CreativeService',
  'CurrentUserService',
  'DataService',
  'ExamplesService',
  'localStorageService'
];
